<div *ngIf="config?.value">
  <ul *ngFor="let map of config?.value | keyvalue">
    <li *ngIf="isVisible(''+map.key+'')">
      <img src="/assets/images/Icones/flag/{{ map.key }}.svg" width="20" height="16" loading="lazy" />
      <span [innerHTML]="map.value"></span>
    </li>
  </ul>
</div>